import * as React from "react";
import styles from '../styles/pokemon.module.scss';
import { ImageFit, IStackTokens, Image, Stack } from "@fluentui/react";
import LanguageFC from "./Language";
import GlobalContext from "../_contexts/GlobalContext";
import { useContext } from "react";

export interface IHeaderFCProps {
    // eslint-disable-next-line
}

const HeaderFC : React.FunctionComponent<IHeaderFCProps> = (props : IHeaderFCProps) => {
    const { GlobalImagesVersion } = useContext(GlobalContext);
    
    const cardTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    return (
        <div className={`${styles.headerMain}`}>
            <Stack horizontal horizontalAlign='center' style={{width:"100%"}}>
                <Image onClick={() => {window.location.href = '/'}} className={styles.mainLogo} src={`${process.env.PUBLIC_URL}/assets/pokemon kaarten.webp?v=${GlobalImagesVersion}`} alt="" imageFit={ImageFit.contain} />  
                <LanguageFC/>
            </Stack>
        </div>
    );
}

export default HeaderFC;